import { z } from 'zod';
/** Product keys are lowercase slugs, e.g. `ssc`. */
export const ProductKey = z
    .string()
    .regex(/^[a-z][a-z0-9_]{1,31}$/, 'Lowercase letters, digits or _, starting with a letter (2-32 chars)');
export const Uuid = z.uuid();
/** Every non-2xx API response uses this envelope. */
export const ErrorResponse = z.object({
    error: z.object({
        code: z.string().describe('Stable machine-readable code, e.g. `validation_failed`'),
        message: z.string().describe('Safe, human-readable message (never a stack trace)'),
        requestId: z.string().optional(),
        details: z.record(z.string(), z.unknown()).optional(),
    }),
});
//# sourceMappingURL=primitives.js.map